import { paths } from '@/constants/paths'
import { Seo } from '@/layout/Seo'
import { useCanonicalUrl } from '@/layout/Seo/useCanonicalUrl/useCanonicalUrl'
import { LegalLayout } from '@/layouts/LegalLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildTerms_2024_10_01 } from './2024_10_01'

const TermsOfUsePage: NextPageWithLayout = () => {
  const canonical = useCanonicalUrl(paths.legal.guildTerms)
  const title = 'Angel Guild Terms of Service | Angel'

  return (
    <>
      <Seo
        canonical={canonical}
        title={title}
        description="Terms of Service for the Angel Guild membership program."
        openGraph={{
          title,
          url: canonical,
          site_name: 'Angel',
        }}
        path={paths.legal.guildTerms}
      />
      <GuildTerms_2024_10_01 />
    </>
  )
}

TermsOfUsePage.getLayout = (page) => {
  return <LegalLayout>{page}</LegalLayout>
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/legal/guild/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'account'])),
      },
      revalidate: false,
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

export default TermsOfUsePage
